import { useMemo } from "react";
import { useAppSelector } from "../store/store";
import { IInstalledExtension } from "../models/intalled-extensions";

export const useInstalledExtensions = (
  extensionCode?: string
): [boolean, IInstalledExtension[]] => {
  const installedExtensions = useAppSelector(
    (state) => state.installedExtensions.extensions
  );

  const hasExtension = useMemo(
    () =>
      !!installedExtensions.find(
        (extension) => extension.code === extensionCode
      ),
    [installedExtensions, extensionCode]
  );

  return [hasExtension, installedExtensions];
};
